import React, { useEffect } from 'react';
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  Typography,
  Avatar,
} from "@material-tailwind/react";

export default function MyProfileModal({ userInfo, onClose }) {
  if (!userInfo) return null;


  const { name, photoURL, createdAt, thoughtCount, totalSize } = userInfo;

  const formattedDate = createdAt
    ? new Date(
        typeof createdAt === "object" && createdAt.seconds
          ? createdAt.seconds * 1000
          : createdAt
      ).toLocaleDateString()
    : "Unknown";

  return (
    <Dialog open={true} handler={onClose} size="sm">
      <DialogHeader>
        <div className="flex items-center gap-4">
          <Avatar
            src={photoURL || "https://www.gravatar.com/avatar/?d=mp"}
            alt="profile photo"
            size="lg"
          />
          <div>
            <Typography variant="h6" className="mb-1">
              {name || "Unnamed User"}
            </Typography>
            <Typography variant="small" className="text-gray-600">
              Joined on {formattedDate}
            </Typography>
          </div>
        </div>
      </DialogHeader>

      <DialogBody className="text-sm">
        <div className="space-y-3">
          <div>
            <Typography variant="small" className="text-gray-500">
              Number of Thoughts
            </Typography>
            <Typography variant="paragraph" className="font-medium">
              {thoughtCount ?? 0}
            </Typography>
          </div>

          <div>
            <Typography variant="small" className="text-gray-500">
              Total Storage
            </Typography>
            <Typography variant="paragraph" className="font-medium">
              {totalSize > 1024 * 1024
                ? `${(totalSize / (1024 * 1024)).toFixed(2)} MB`
                : `${(totalSize / 1024).toFixed(1)} KB`}
            </Typography>
          </div>
        </div>
      </DialogBody>

      <DialogFooter>
        <Button variant="outlined" color="gray" onClick={onClose}>
          Close
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
